import { render, staticRenderFns } from "./sales-statistics.vue?vue&type=template&id=9c37c558&"
import script from "./sales-statistics.vue?vue&type=script&lang=ts&"
export * from "./sales-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports